export default "__VITE_ASSET__Ko2r6e4g__"